export function getConsent (t) {
  return t.get('organization', 'private', 'consent', true)
}

export function setConsent (t, consent) {
  return t.set('organization', 'private', 'consent', consent)
}

export function getConfig (t) {
  return t.get('board', 'shared')
}

export function setConfig (t, data) {
  return t.set('board', 'shared', data)
}

export function getTargetList (t) {
  return getConfig(t).then(conf => [(conf.targetId && conf.targetId !== 'same') ? conf.targetId : t.list('id').get('id'), conf.position || 'bottom'])
}
